import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { createAplicacionOfflineFirst } from '../../services/offline/syncQueue';
import { obtenerMisProductoresAsignados } from '../../services/productoresEncargado';
import AppShell from '../../components/layout/AppShell';
import AplicacionForm from '../../components/aplicaciones/AplicacionForm';

function NuevaAplicacionPage() {
  const { user, productor } = useAuth();
  const navigate = useNavigate();

  const [productores, setProductores] = useState([]);
  const [productoresStatus, setProductoresStatus] = useState('loading');

  useEffect(() => {
    let active = true;
    setProductoresStatus('loading');
    obtenerMisProductoresAsignados(user?.id).then((result) => {
      if (!active) return;
      if (result.ok) setProductores(result.productores);
      setProductoresStatus('ready');
    });
    return () => {
      active = false;
    };
  }, [user?.id]);

  const handleSubmit = async (payload) => {
    const result = await createAplicacionOfflineFirst(user.id, payload);

    if (result.ok && result.offline) {
      // Sin id de servidor todavía: no hay detalle al que ir, se vuelve al
      // listado, donde la tarjeta aparece como PENDIENTE DE SINCRONIZAR.
      navigate('/aplicaciones', { state: { justSavedOffline: true }, replace: true });
    } else if (result.ok) {
      navigate(`/aplicaciones/${result.id}`, { state: { justCreated: true }, replace: true });
    }

    return result;
  };

  return (
    <AppShell title="Nueva aplicación">
      <AplicacionForm
        mode="create"
        productorNombre={productores[0]?.nombre || productor?.nombre}
        productores={productores}
        productoresStatus={productoresStatus}
        onSubmit={handleSubmit}
        cancelTo="/aplicaciones"
      />
    </AppShell>
  );
}

export default NuevaAplicacionPage;
